export default "/images/megamenu-img.png?8b069df40f2e8fc97bf9465bb96e21f7";